const ConfirmedBooking = () => {
  return (
    <main className="confirmed-booking">
      <h1>Your booking has been confirmed!</h1>
      <p>Thank you for choosing Little Lemon.</p>
    </main>
  );
};

export default ConfirmedBooking;
